import { DesignEntity } from '@/lib/enums';

export default function isEmptyState({ designs, supporterMap, user }) {
  if (!designs?.size) {
    return true;
  }

  let isEmpty = true;

  Array.from(designs.values()).forEach((designData) => {
    if (!isEmpty) {
      return;
    }

    const snapshotEntityMap = designData?.snapshotEntityMap;
    const personId = user?.person?.uuid;

    const role = Array.from(
      snapshotEntityMap?.get(DesignEntity.ROLE)?.values() ?? []
    ).find((role) => personId && role.person_uuid === personId);

    if (role) {
      isEmpty = false;
      return;
    }

    const group = Array.from(
      snapshotEntityMap?.get(DesignEntity.GROUP)?.values() ?? []
    ).find((group) => {
      const isSupporter =
        user?.id && supporterMap?.get(group.uuid)?.has(user.id);
      return isSupporter || (personId && group.lead_uuid === personId);
    });

    if (group || role) {
      isEmpty = false;
    }
  });

  return isEmpty;
}
